import { Component, ElementRef, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { PortalService } from 'src/services/portal.service';
import { AlertController, IonContent, LoadingController, Platform } from '@ionic/angular';
import * as moment from 'moment';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
//@ts-ignore
import fetchProgress from 'fetch-progress';

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
})

export class HomePage {

  @ViewChild('content', { static: false }) content: IonContent;
  @ViewChild('pRef', { static: true }) pRef: ElementRef;
  TITULO = {
    GERAL: `<b>Painel</b> Coronavírus`,
    SRAG: `<b>SRAG</b> Síndrome Respiratória Aguda Grave`,
    LEITOS: `<b>Ocupação</b> de Leitos`,
    INSUMOS: `<b>Envio</b> de Insumos`,
    SOBRE: `<b>Sobre</b> o Painel`,
  };

  geral: any = {};
  dtAtualizacao: any;
  dtAtualizacaoSrag: any;
  full: any;
  versao = 'v2.2.0';
  total = 100;
  progress = 20;
  statusSelected = 'GERAL';
  color = 'red'

  constructor(private portal: PortalService,
    private inAppBrowser: InAppBrowser,
    public platform: Platform,
    private alertCtrl: AlertController,
    private loadingController: LoadingController) {

  }

  ionViewDidEnter() {
    console.log('ngOnInit -> HomePage');
    this.loadGeral();
  }

  onScrollToTop() {
    this.content.scrollToTop(500);
  }

  contentScrollToPoint(data: any) {
    if (data && data.point) {
      this.content.scrollToPoint(null, (data.point - 22), 500);
    }
  }

  selectStatus(status) {
    this.content.scrollToTop(0);
    this.statusSelected = status;
    if (status === 'Painel Interativo') {
      if (this.platform.is('cordova')) {
        this.inAppBrowser.create('https://infoms.saude.gov.br/extensions/covid-19_html/covid-19_html.html', '_system', 'location=no');
      } else {
        this.inAppBrowser.create('https://infoms.saude.gov.br/extensions/covid-19_html/covid-19_html.html', '_blank');
      }
    } else if (status === 'OpenDATASUS') {
      if (this.platform.is('cordova')) {
        this.inAppBrowser.create('https://opendatasus.saude.gov.br/', '_system', 'location=no');
      } else {
        this.inAppBrowser.create('https://opendatasus.saude.gov.br/', '_blank');
      }
    }
  }

  async loadGeral() {

    const geral = await this.portal.getCDN('PortalGeral');
    const full = await this.portal.getGeral();
    this.geral = geral[0];
    this.full = full;
    this.versao = this.geral.versao;
    this.dtAtualizacao = this.geral.dt_atualizacao;
    this.dtAtualizacaoSrag = this.geral.dt_atualizacao_srag;
  }

  irLoja(loja) {
    if (loja === 'Google Play') {
      window.open('https://play.google.com/store/apps/details?id=br.gov.datasus.guardioes&hl=pt-br', '_blank');
    }
    if (loja === 'App Store') {
      window.open('https://apps.apple.com/br/app/coronav%C3%ADrus-sus/id1408008382', '_blank');
    }
    if (loja === 'Web App') {
      window.open('https://coronavirus-app.saude.gov.br/', '_blank');
    }
  }

  async download() {
    const alert = await this.alertCtrl.create({
      message: `Download...
      <div class="progress-bar-container">
        <div class="progress-bar green" pRef
          [ngStyle]="{'width': progress + '%'}">
        </div>
      </div>`
    });
    alert.present();
    let nome = this.geral.texto_rodape;
    let url = this.geral.arquivo.url;
    var self = this;
    if (this.statusSelected !== 'GERAL') {
      alert.dismiss();
      window.open('https://opendatasus.saude.gov.br/dataset/bd-srag-2020', '_blank');
      //nome = 'arquivo_srag.csv';
      //url = this.geral.arquivo_srag.url;
    } else {
      fetch(url)
        .then(
          fetchProgress({
            onProgress(progress) {
              //self.progress = progress
              var percente = ((progress.transferred / progress.total) * 100)
              var element = document.getElementsByClassName("progress-bar").item(0)
              element.setAttribute('style', 'width:' + percente + '%')
            },
            onError(err) {
              console.log(err);
              alert.dismiss();
            },
          })
        )
        .then(resp => resp.blob())
        .then(blob => {
          alert.dismiss();
          const url = window.URL.createObjectURL(blob);
          const element = document.createElement('a');
          // element.setAttribute('href', 'data:attachment/image' + base64);
          element.setAttribute('href', url);
          element.setAttribute('download', nome);
          document.body.appendChild(element);
          element.click();
        });
    }
    // window.location.assign(this.geral.arquivo.url);
  }
}
